import api from "./api";

// 系列课程商品列表
export const postEquipmentList = params => {
  return api("post", `/v1/management/equipment-commodity/list`, params);
};

// 根据名称或者SKU查询商品
export const getEquipmentBySku = params => {
  return api("post", `/v1/management/equipment-commodity/equipmentBySku`, params);
};

// 根据名称或者TagId查询商品
export const getEquipmentByTagId = id => {
  return api("get", `/v1/management/equipment-commodity/equipmentByTagId/${id}`);
};

// 系列课程商品管理列表
export const quipmentManagementList = params => {
  return api("get", `/v1/management/equipment-commodity/equipmentManagementList`, params);
};

// 保存商品
export const postEquipmentSave = params => {
  return api("post", `/v1/management/equipment-commodity/saveEquipment`, params);
};

// 获取ec链接
export const getEcUrl = (sku, params) => {
  return api("post", `/v1/management/equipment-commodity/getEcUrl/${sku}`, params);
};
